import React from "react";
import { Link } from "react-router-dom";
import defaultImage from "../../assets/default-image.jpg";
import arrow from "../../assets/arrow-nav.png";
import moment from "moment";

const Navigation = ({ validPrev, validNext, handleNavigation }) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <img
        src={arrow}
        alt="arrow-next"
        style={{
          transform: "rotate(180deg)",
          height: 40,
          cursor: validPrev ? "pointer" : "not-allowed",
          opacity: validPrev ? 1 : "0.3",
        }}
        onClick={() => (validPrev ? handleNavigation("prev") : null)}
      />
      <img
        src={arrow}
        alt="arrow-next"
        style={{
          height: 40,
          cursor: validNext ? "pointer" : "not-allowed",
          opacity: validNext ? 1 : "0.3",
          marginLeft: 5,
        }}
        onClick={() => (validNext ? handleNavigation("next") : null)}
      />
    </div>
  );
};

export default ({
  listBlog,
  handleViewDetil,
  baseURL,
  handleNavigation,
  validPrev,
  validNext,
  onLoad,
}) => {
  return (
    <div className="col-lg-9 col-md-12 col-sm-12 col-12 col-psre-2">
      <div className="row">
        {onLoad ? (
          <p>Loading ... </p>
        ) : listBlog.length ? (
          listBlog.map((e) => {
            return (
              <div className="col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
                <Link
                  target="_blank"
                  to={`/blog/${e._id}`}
                  style={{ color: "black" }}
                >
                  <img
                    className="mb-4"
                    src={e.picture ? baseURL + e.picture : defaultImage}
                    alt={e._id}
                    style={{
                      width: "100%",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <p
                    className="clamp-word"
                    style={{
                      fontSize: "14px",
                      fontWeight: "600",
                      textAlign: "justify",
                    }}
                  >
                    {e.title}
                  </p>
                  <div className="space-between" style={{ fontSize: "12px" }}>
                    <div>
                      <p className="text-muted mb-1">Kategori Artikel</p>
                      <p className="text-muted">{e.category}</p>
                    </div>
                    <div>
                      <p className="text-muted mb-1" style={{ fontSize: "12px" }}>
                        {e.commentsData.length} Komentar
                      </p>
                      <p className="text-muted" style={{ fontSize: "12px" }}>{moment(e.createdAt).format("DD-MM-YYYY h:mm A")}</p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })
        ) : (
          <div>No data founded</div>
        )}
      </div>
      {listBlog.length || validPrev || validPrev ? (
        <Navigation
          validPrev={validPrev}
          validNext={validNext}
          handleNavigation={handleNavigation}
        />
      ) : null}
    </div>
  );
};
